@if (relations.length) {
  @if (!textComponent) {
    Related products
    <div class="col-xs-12 relations-cntr" style="padding-left: 0">
      @for (relation of relations; track relation) {
        <div>
          <pub-render-relation [relation]="relation" [isReversed]="isReversed(relation)" [textComponent]="textComponent"
          (conceptSelected)="selectConcept($event)"></pub-render-relation>
        </div>
      }
    </div>
  }
  @if (textComponent) {
    @for (relation of relations; track relation) {
      <div>
        <pub-render-relation [relation]="relation" [isReversed]="isReversed(relation)" [textComponent]="textComponent"
        (conceptSelected)="selectConcept($event)"></pub-render-relation>
      </div>
    }
  }
}
